import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, Images, tagEnums, useModal, sessionStatusEnums, FindSuccessItem, useSecondaryModal } from 'utils';
import { ManageActions, MinLoader, SessionTimer, SimpleTooltip } from 'components';
import { httpRequestsOnSuccessActions, sessionActions, tagActions } from 'store';
import { cardViewEnums } from '../constants';
import { SessionFilters } from './sessionFilters';
import { SessionDetails } from './sessionDetails';
import { CompleteAppt } from '../../../schedule/core/modals/apptDetail/completeAppt';
import { apptEnums } from '../../../schedule/core/constants';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { CreateSession } from '../createSession';
import { EditSessionTimeline } from '../editSessionTimeline';
import { SessionDocumentation } from '../documentation';
import noteNewStyle from "../../../../assets/images/icons/noteNewStyle.svg";

const PAUSE_ACTION = 'PAUSE_SESSION';
const RESUME_ACTION = 'RESUME_SESSION';
const END_ACTION = 'END_SESSION';
const REFRESH_ACTION = 'REFRESH_SESSION';
export const SessionHeader = ({ filters, setFilters }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const sessionById = useSelector((state) => state.session.sessionById);
    const appt = useSelector((state) => state.appointment.appointmentById);
    const loadPause = FindLoad(PAUSE_ACTION);
    const loadResume = FindLoad(RESUME_ACTION);
    const loadComplete = FindLoad(END_ACTION);
    const loadRefresh = FindLoad(REFRESH_ACTION);
    const successResume = FindSuccessItem(RESUME_ACTION);
    const successPause = FindSuccessItem(PAUSE_ACTION);
    const successEnd = FindSuccessItem(END_ACTION);
    const { open, close } = useModal();
    const { openSecondary, closeSecondary } = useSecondaryModal();
    const handleCloseRef = useRef(null);
    const [editTimelineOpen, setEditTimelineOpen] = useState(false);
    const [documentationOpen, setDocumentationOpen] = useState(false);

    const handleAction = (name, handleClose) => {
        handleCloseRef.current = handleClose;

        if (name === 'resume') {
            dispatch(sessionActions.resumeSession(sessionById?.id));
        }
        if (name === 'pause') {
            dispatch(sessionActions.pauseSession(sessionById?.id));
        }
        if (name === 'end') {
            dispatch(sessionActions.endSession(sessionById?.id));
        }
    };

    const changeFilters = (name, type) => {
        const params = { ...filters };
        type ? (params[name] = type) : delete params[name];
        setFilters(params);
    };

    useEffect(() => {
        if (successResume || successPause) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(RESUME_ACTION));
            dispatch(httpRequestsOnSuccessActions.removeSuccess(PAUSE_ACTION));

            if (handleCloseRef.current) {
                handleCloseRef.current();
                handleCloseRef.current = null;
            }
        }
        if (successEnd) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(END_ACTION));
            openCompleteModal();
            // open(<CompleteAppt handleClose={close} />);
            if (handleCloseRef.current) {
                handleCloseRef.current();
                handleCloseRef.current = null;
            }
        }
    }, [successResume, successPause, successEnd]);

    const openCompleteModal = () => {
        openSecondary(<CompleteAppt handleClose={closeSecondary} fromSession={true} />);
    };

    return (
        <div className="session-header-box">
            <div className="session-back-btn-box">
                <button onClick={() => navigate('/schedule')}>
                    <img src={Images.backArrow} alt="back" />
                </button>
                <p>{`${sessionById?.appt?.client?.fullName}${sessionById?.appt?.startDate ? `, ${moment.utc(sessionById?.appt?.startDate).format('MM/DD/YYYY')}` : ''}`}</p>
            </div>

            <div className="flex-align-center" style={{ gap: 10 }}>
                <div className="search-for-goal-box">
                    <input
                        type="text"
                        placeholder="Search for goals.."
                        onChange={(e) => {
                            const params = {
                                ...filters,
                            };
                            if (e.target.value === '') {
                                delete params['search'];
                            } else {
                                params['search'] = e.target.value;
                            }
                            setFilters(params);
                        }}
                    />
                    <button>
                        <img src={Images.searchIcon} alt="search" />
                    </button>
                </div>

                <SessionFilters saveFilters={setFilters} savedFilters={filters} />

                {/*<button*/}
                {/*    onClick={() => {*/}
                {/*        let newSort;*/}
                {/*        if (!filters?.sort) {*/}
                {/*            newSort = 'asc';*/}
                {/*        } else if (filters?.sort === 'asc') {*/}
                {/*            newSort = 'desc';*/}
                {/*        } else {*/}
                {/*            newSort = '';*/}
                {/*        }*/}
                {/*        changeFilters('sort', newSort);*/}
                {/*    }}*/}
                {/*    className={filters?.sort ? 'session-header-active-btn-box' : 'session-gray-action-btn-box'}*/}
                {/*>*/}
                {/*    <img*/}
                {/*        style={{*/}
                {/*            transition: 'transform 0.3s ease',*/}
                {/*            transform:*/}
                {/*                filters?.sort === 'desc'*/}
                {/*                    ? 'rotate(0deg)'*/}
                {/*                    : filters?.sort === 'asc'*/}
                {/*                        ? 'rotate(180deg)'*/}
                {/*                        : 'none',*/}
                {/*        }}*/}
                {/*        src={Images.latestEarliest} alt="filter"*/}
                {/*    />*/}
                {/*</button>*/}

                <SimpleTooltip title={'Click to reload all updated session details for this active session.'} placement="top" arow>
                    <button
                        onClick={() => dispatch(sessionActions.refreshSession(sessionById?.id))}
                        className="session-gray-action-btn-box"
                    >
                        {loadRefresh?.length ? (
                            <MinLoader margin={'0'} color={'#344054'} position={'relative'} />
                        ) : (
                            <img src={Images.refresh} alt="filter" />
                        )}
                    </button>
                </SimpleTooltip>

                <button onClick={() => open(<SessionDetails />)} className="session-gray-action-btn-box">
                    <img src={Images.infoCircle} alt="filter" />
                </button>

                <button
                    style={{ opacity: sessionById?.status === sessionStatusEnums.IN_PROGRESS ? 1 : 0.4 }}
                    disabled={sessionById?.status !== sessionStatusEnums.IN_PROGRESS}
                    className="session-gray-action-btn-box"
                    onClick={() => setDocumentationOpen(true)}
                >
                    <img src={Images.noteNewStyle} alt="documentation" />
                </button>

                <button
                    disabled={sessionById?.status === sessionStatusEnums.COMPLETED}
                    style={{ width: '130px', gap: 8, opacity: sessionById?.status === sessionStatusEnums.IN_PROGRESS ? 1 : 0.4 }}
                    onClick={() =>
                        openSecondary(
                            <CreateSession
                                info={sessionById}
                                afterSuccess={() => {
                                    closeSecondary();
                                }}
                            />
                        )
                    }
                    className="session-gray-action-btn-box"
                >
                    <img src={Images.sessionEditGoal} alt="filter" />
                    <p>Edit Goals</p>
                </button>

                <div className="session-header-line" />

                <ManageActions
                    btnIcon={filters?.viewType === cardViewEnums.GRID ? Images.sessionGrid : Images.sessionList}
                    headerTitle={'Manage View'}
                    btnClass={filters?.viewType ? 'session-header-active-btn-box' : 'session-gray-action-btn-box'}
                    renderBody={(handleClose) => (
                        <div>
                            <button
                                onClick={() => {
                                    changeFilters('viewType', cardViewEnums.GRID);
                                    handleClose();
                                }}
                                className={
                                    filters?.viewType === cardViewEnums.GRID
                                        ? 'session-grid-list-active-btn-box'
                                        : 'session-grid-list-btn-box'
                                }
                            >
                                <img src={Images.sessionGrid} alt="grid" />
                                <p>Card </p>
                            </button>
                            <button
                                onClick={() => {
                                    changeFilters('viewType', cardViewEnums.LIST);
                                    handleClose();
                                }}
                                className={
                                    filters?.viewType === cardViewEnums.LIST
                                        ? 'session-grid-list-active-btn-box'
                                        : 'session-grid-list-btn-box'
                                }
                                style={{ marginBottom: 0 }}
                            >
                                <img src={Images.sessionList} alt="list" />
                                <p>List </p>
                            </button>
                        </div>
                    )}
                />

                {appt?.status === apptEnums?.PENDING && sessionById?.status === apptEnums?.COMPLETED ? (
                    <button onClick={openCompleteModal} className="session-header-timer">
                        <p>
                            <SessionTimer sessionById={sessionById} />
                        </p>
                    </button>
                ) : (
                    <ManageActions
                        disabled={sessionById?.status === sessionStatusEnums.COMPLETED}
                        btnIcon={
                            sessionById?.status === sessionStatusEnums.COMPLETED
                                ? ''
                                : sessionById?.status === sessionStatusEnums.IN_PROGRESS
                                  ? Images.pauseCircle
                                  : sessionById?.status === sessionStatusEnums.PAUSED
                                    ? Images.play
                                    : Images.stopCircle
                        }
                        btnTitle={<SessionTimer sessionById={sessionById} />}
                        headerTitle={'Manage session controls'}
                        btnClass={
                            sessionById?.status === sessionStatusEnums.IN_PROGRESS ? 'session-header-timer-active' : 'session-header-timer'
                        }
                        renderBody={(handleClose) => (
                            <div>
                                {sessionById?.status === sessionStatusEnums.PAUSED && (
                                    <button
                                        onClick={() => {
                                            handleAction('resume', handleClose);
                                        }}
                                        className="session-timer-btn-box"
                                    >
                                        {loadResume?.length ? (
                                            <MinLoader margin={'0'} color={'white'} position={'relative'} />
                                        ) : (
                                            <img src={Images.play} alt="grid" />
                                        )}
                                        <p>Resume Session </p>
                                    </button>
                                )}
                                {sessionById?.status === sessionStatusEnums.IN_PROGRESS && (
                                    <button
                                        onClick={() => {
                                            handleAction('pause', handleClose);
                                        }}
                                        className="session-timer-btn-box"
                                    >
                                        {loadPause?.length ? (
                                            <MinLoader margin={'0'} color={'white'} position={'relative'} />
                                        ) : (
                                            <img
                                                style={{
                                                    filter: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7498%) hue-rotate(184deg) brightness(117%) contrast(97%)',
                                                }}
                                                src={Images.pauseCircle}
                                                alt="list"
                                            />
                                        )}
                                        <p>Pause Session </p>
                                    </button>
                                )}
                                <button
                                    onClick={() => {
                                        handleAction('end', handleClose);
                                    }}
                                    style={{ background: '#D92D20', borderColor: '#D92D20', marginBottom: 12 }}
                                    className="session-timer-btn-box"
                                >
                                    {loadComplete?.length ? (
                                        <MinLoader width={'20px'} margin={'0'} color={'white'} position={'relative'} />
                                    ) : (
                                        <img src={Images.stopCircle} alt="list" style={{ width: '20px' }} />
                                    )}
                                    <p>End Session</p>
                                </button>
                                <button
                                    onClick={() => {
                                        handleClose();
                                        setEditTimelineOpen(true);
                                    }}
                                    style={{ background: 'white', borderColor: '#D5D7DA', marginBottom: 0 }}
                                    className="session-timer-btn-box session-edit-time-btn"
                                >
                                    <img src={Images.editPenUnderline} alt="editPen" />
                                    {/*<i className="fa fa-pencil" style={{ color: '#414651' }} />*/}
                                    <p style={{ color: '#414651' }}>Edit Session Time</p>
                                </button>
                            </div>
                        )}
                    />
                )}
            </div>

            <EditSessionTimeline open={editTimelineOpen} onClose={() => setEditTimelineOpen(false)} />
            <SessionDocumentation open={documentationOpen} onClose={() => setDocumentationOpen(false)} />
        </div>
    );
};
